import {Component, AfterViewInit} from '@angular/core';
import {BaseComponent} from '../../../base/base.component';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {CreateDaycareChildGQL, GetUnitiesGQL, Unity, User} from '../../../../generated/graphql';
import {UserService} from '../../../service/user.service';

/**
 * Fatia 5D — CRIAR criança. O colaborador é restaurado-ou-criado por (RE + unidade)
 * no back (§47.6.D). Só admin/local-manager; seletor de unidade só p/ admin.
 */
@Component({
    selector: 'app-daycare-child-create',
    templateUrl: './daycare-child-create.component.html',
    styleUrls: ['./daycare-child-create.component.scss']
})
export class DaycareChildCreateComponent extends BaseComponent implements AfterViewInit {

    user = new User();
    showUnitySelector = false;
    unities: Array<Unity> = [];
    loading = false;

    form = {name: '', employeeRe: '', employeeName: '', employeeEmail: '', year: null, unityId: null};
    guardians: Array<{ kind: string, name: string, documentRaw: string }> = [];

    constructor(public router: Router,
                public translate: TranslateService,
                public userService: UserService,
                private createChildGQL: CreateDaycareChildGQL,
                private getUnitiesGQL: GetUnitiesGQL
    ) {
        super(router, translate);
    }

    ngAfterViewInit(): void {
        this.userService.user.subscribe({
            next: data => {
                this.user = data as User;
                this.actionUserProfileBTN();
                if (this.actionUserProfile() === false) {
                    super.showMessage(this.translate.instant('atencao'), this.translate.instant('semacesso'), 'warning');
                    this.router.navigate(['/']);
                    return;
                }
                if (this.showUnitySelector) {
                    this.loadUnities();
                }
            }, error: err => super.onError(err)
        });
    }

    loadUnities() {
        this.getUnitiesGQL.watch().valueChanges.subscribe(({data}) => {
            this.unities = (data.unities || []) as Array<Unity>;
        }, error => super.onError(error));
    }

    addGuardianRow() {
        this.guardians.push({kind: 'authorized', name: '', documentRaw: ''});
    }

    removeGuardianRow(i: number) {
        this.guardians.splice(i, 1);
    }

    save() {
        if (this.showUnitySelector && !this.form.unityId) {
            super.showMessage(this.translate.instant('atencao'), this.translate.instant('daycare.selecioneunidade'), 'warning');
            return;
        }
        if (!this.form.name.trim() || !this.form.employeeRe.trim() || !this.form.employeeName.trim()) {
            super.showMessage(this.translate.instant('atencao'), this.translate.instant('daycare.camposobrigatorios'), 'warning');
            return;
        }
        const guardians = this.guardians
            .filter(g => g.name && g.name.trim())
            .map(g => ({kind: g.kind, name: g.name, documentRaw: g.documentRaw || ''}));

        this.loading = true;
        this.createChildGQL.mutate({
            data: {
                name: this.form.name,
                employeeRe: this.form.employeeRe,
                employeeName: this.form.employeeName,
                employeeEmail: this.form.employeeEmail || '',
                year: this.form.year ? Number(this.form.year) : null,
                unityId: this.showUnitySelector ? this.form.unityId : null,
                guardians: guardians.length ? guardians : null
            }
        }).subscribe({
            next: ({data}) => {
                this.loading = false;
                super.showMessage(this.translate.instant('success'), this.translate.instant('daycare.criancacriada'), 'success');
                this.router.navigate(['/daycare/detail/' + data.createDaycareChild.id]);
            }, error: err => {
                this.loading = false;
                super.onError(err);
            }
        });
    }

    actionUserProfile(): boolean {
        switch (this.user.profile) {
            case 'admin':
                return true;
            case 'local-manager':
                return true;
            default:
                return false;
        }
    }

    actionUserProfileBTN() {
        this.showUnitySelector = this.user.profile === 'admin';
    }
}
